import { Roles } from "../../../mp-utils/generic-utils"
import { db, database } from "../../../mp-database"
export const APP_EBOOKS_MODIFY = "APP_EBOOKS_MODIFY"

export const getEbooksById = id => {
  return dispatch => {
    dispatch(
      setEbooksData({
        isFetched: false,
        ebooks: []
      })
    )
    db.collection("ebooks")
      .doc(id)
      .get()
      .then(sn => {
        let data = sn.data()
        dispatch(
          setEbooksData({
            ebooks: data.ebooks,
            isFetched: true
          })
        )
      })
  }
}

export const setEbooksData = payload => {
  return {
    type: APP_EBOOKS_MODIFY,
    payload
  }
}
